import {useEffect, useRef} from 'react';
import {useSearchParams} from 'react-router';
import useGenerateInitialVersionStore from '../../../../stores/useGenerateInitialVersionStore';

/**
 * Hook to initialize the Generate Initial Version store from URL params.
 * Should be called once at a high level for disclosures.
 *
 * This enables:
 * - URL state restoration on page reload
 * - No re-renders from URL changes (only reads once)
 *
 * @param {boolean} isDisclosure - Whether the current report is a disclosure
 */
export function useGenerateInitialOnMount(isDisclosure) {
    const [searchParams] = useSearchParams();
    const initFromUrl = useGenerateInitialVersionStore(s => s.initFromUrl);
    const _initialized = useGenerateInitialVersionStore(s => s._initialized);
    const hasChecked = useRef(false);

    useEffect(() => {
        // Only check once, and only for disclosures
        if (hasChecked.current || !isDisclosure || _initialized) return;
        hasChecked.current = true;

        initFromUrl(searchParams);
    }, [isDisclosure, searchParams, initFromUrl, _initialized]);
}
